import { Flame } from 'lucide-react';
import { OrbitIcon } from "@/components/icons/OrbitIcon";

export default function StreakChip() {
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-amber-500/10 px-2.5 py-1 text-xs font-medium text-amber-500 ring-1 ring-amber-500/20">
      <OrbitIcon name="flame.fill" fallback={Flame} className="h-3.5 w-3.5" />
      7 day streak
    </span>
  );
}
